export const CHECKOUT_PLANS = {
    SINGLE_ORDER: 'single_order',
    RECURRING_ORDER: 'recurring_order',
    MILESTONES_ORDER: 'milestones_order'
};
